type ApiError = {
  data?: {
    errorCode?: string
  }
}

type FetchError = {
  error?: ApiError
}

const FOLLOWERS_LIST_HIDDEN_ERROR_CODE = 'FollowersListHidden'
const FOLLOWING_LIST_HIDDEN_ERROR_CODE = 'FollowingListHidden'

export const isHiddenListError = (error: unknown): boolean => {
  const apiError = error as ApiError
  const errorCode = apiError?.data?.errorCode
  return (
    errorCode === FOLLOWERS_LIST_HIDDEN_ERROR_CODE ||
    errorCode === FOLLOWING_LIST_HIDDEN_ERROR_CODE
  )
}

export const isHiddenListFetchError = (error: unknown): boolean => {
  const fetchError = error as FetchError
  const errorCode = (fetchError?.error?.data as { errorCode?: string })
    ?.errorCode
  return (
    errorCode === FOLLOWERS_LIST_HIDDEN_ERROR_CODE ||
    errorCode === FOLLOWING_LIST_HIDDEN_ERROR_CODE
  )
}
